import { Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { ProductPackageLabelDialogComponent } from './product-package-label-dialog.component';

@Injectable({ providedIn: 'root' })
export class ProductLabelDialogService {
  constructor(private readonly dialog: Dialog) {}

  open(uuid: string, theme: 'dark' | 'light'): void {
    if (!uuid) {
      return;
    }
    this.dialog.open(ProductPackageLabelDialogComponent, {
      width: '620px',
      maxWidth: '96vw',
      maxHeight: '92vh',
      ariaLabelledBy: 'package-label-title',
      data: { uuid, theme }
    });
  }
}
